import React, { useMemo, useState } from "react"
import {
  Form,
  Button,
  Row,
  Card,
  Input,
  Table,
  Checkbox,
  Modal,
  Spin,
} from "antd"
import Title from "antd/es/typography/Title"
import { useNavigate, useLocation } from "react-router-dom"
import Navbar from "../../components/Navbar/Navbar"
import { usePostRequest } from "../../hooks/usePostRequest"
import { UsePostRequest } from "../../utils/api/ApiRequests"
import moment from "moment"
import "../../../src/cssFiles/CustomStyles/Payroll.css"
import { extractAmount, getSum, isValidNumber } from "../../utils/Common"
import toast from "react-hot-toast"

const AddSubmitButton = ({ form, isLoading }) => {
  const [submittable, setSubmittable] = useState(true)
  const values = Form.useWatch([], form)

  // React.useEffect(() => {
  //   form
  //     .validateFields({
  //       validateOnly: true,
  //     })
  //     .then(
  //       () => {
  //         setSubmittable(true)
  //       },
  //       () => {
  //         setSubmittable(false)
  //       }
  //     )
  // }, [values, form])

  React.useEffect(() => {
    const allFields = form.getFieldsValue(true); // Get all fields, including undefined ones
  
    form
      .validateFields()
      .then(
        () => {
          const hasUndefined = Object.values(allFields).some(value => value === undefined);
          setSubmittable(!hasUndefined);
        },
        () => {
          setSubmittable(false);
        }
      );
  }, [values, form]);

  return (
    <Button
      type="primary"
      htmlType="submit"
      disabled={!submittable}
      loading={isLoading}
    >
      Submit
    </Button>
  )
}

export default function GeneratePayroll() {
  const [form] = Form.useForm()
  const navigate = useNavigate()
  const location = useLocation()
  const salaryType = location.state.salary_type
  const dateFrom = location.state.date_from
  const dateTo = location.state.date_to
  const employmentStatusId = location.state.employment_status_id
  const { callPost, isLoading } = usePostRequest(() => {})
  const filterConfig = useMemo(
    () => ({
      salary_type: salaryType || "",
      date_from: moment(dateFrom.$d).format("YYYY-MM-DD"),
      date_to: moment(dateTo.$d).format("YYYY-MM-DD"),
      employee_id: null,
      branch_id: null,
      employment_status_id: employmentStatusId,
      business_unit_id: "",
    }),
    []
  )
  const [tableData, setTableData] = useState([])
  const [isDataLoading, setIsDataLoading] = useState(false)
  const [isThirteenthIncluded, setIsThirteenthIncluded] = useState(false)
  const [saving, setSaving] = useState(false)

  const handleCheckbox = (e) => {
    setIsThirteenthIncluded(e.target.checked)
  }

  const tableColumns = [
    {
      title: "Employee",
      dataIndex: "employee_name",
      // width: 800,
      key: "employee_name",
      render: (text, record, index) => (
        <Form.Item name={[index, "employee_name"]} initialValue={text}>
          <Input disabled />
        </Form.Item>
      ),
    },
    {
      title: "Rate",
      dataIndex: "basic_rate",
      key: "basic_rate",
      render: (text, record, index) => (
        <Form.Item name={[index, "basic_rate"]} initialValue={text}>
          <Input disabled />
        </Form.Item>
      ),
    },
    {
      title: "Work Days",
      dataIndex: "work_days",
      key: "work_days",
      render: (text, record, index) => (
        <Form.Item name={[index, "work_days"]} initialValue={text}>
          <Input disabled />
        </Form.Item>
      ),
    },
    {
      title: "Basic Pay",
      dataIndex: "basic_pay",
      key: "basic_pay",
      render: (text, record, index) => (
        <Form.Item
          name={[index, "basic_pay"]}
          initialValue={extractAmount(text)}
        >
          <Input disabled />
        </Form.Item>
      ),
    },
    {
      title: "Regular OT (hrs)",
      dataIndex: "regular_ot_hr",
      key: "regular_ot_hr",
      render: (text, record, index) => (
        <Form.Item name={[index, "regular_ot_hr"]} initialValue={text}>
          <Input type="number" disabled />
        </Form.Item>
      ),
    },
    {
      title: "Regular OT Pay",
      dataIndex: "regular_ot_pay",
      key: "regular_ot_pay",
      render: (text, record, index) => (
        <Form.Item name={[index, "regular_ot_pay"]} initialValue={text}>
          <Input type="number" disabled />
        </Form.Item>
      ),
    },
    {
      title: "Restday OT (hrs)",
      dataIndex: "restday_ot_hr",
      key: "restday_ot_hr",
      render: (text, record, index) => (
        <Form.Item name={[index, "restday_ot_hr"]} initialValue={text}>
          <Input type="number" disabled />
        </Form.Item>
      ),
    },
    {
      title: "Restday OT Pay",
      dataIndex: "restday_ot_pay",
      key: "restday_ot_pay",
      render: (text, record, index) => (
        <Form.Item name={[index, "restday_ot_pay"]} initialValue={text}>
          <Input type="number" disabled />
        </Form.Item>
      ),
    },
    {
      title: "Regular Holiday Pay",
      dataIndex: "regular_holiday_pay",
      key: "regular_holiday_pay",
      render: (text, record, index) => (
        <Form.Item
          name={[index, "regular_holiday_pay"]}
          initialValue={extractAmount(text)}
        >
          <Input disabled />
        </Form.Item>
      ),
    },
    {
      title: "Special Holiday Pay",
      dataIndex: "special_holiday_pay",
      key: "special_holiday_pay",
      render: (text, record, index) => (
        <Form.Item name={[index, "special_holiday_pay"]} initialValue={0}>
          <Input type="number" disabled />
        </Form.Item>
      ),
    },
    {
      title: "Sick Leave Days",
      dataIndex: "sick_leave_days",
      key: "sick_leave_days",
      render: (text, record, index) => (
        <Form.Item name={[index, "sick_leave_days"]} initialValue={0}>
          <Input type="number" disabled />
        </Form.Item>
      ),
    },
    {
      title: "Sick Leave Pay",
      dataIndex: "sick_leave_pay",
      key: "sick_leave_pay",
      render: (text, record, index) => (
        <Form.Item name={[index, "sick_leave_pay"]} initialValue={0}>
          <Input type="number" disabled />
        </Form.Item>
      ),
    },
    {
      title: "Vacation Leave Days",
      dataIndex: "vacation_leave_days",
      key: "vacation_leave_days",
      render: (text, record, index) => (
        <Form.Item name={[index, "vacation_leave_days"]} initialValue={0}>
          <Input type="number" disabled />
        </Form.Item>
      ),
    },
    {
      title: "Vacation Leave Pay",
      dataIndex: "vacation_leave_pay",
      key: "vacation_leave_pay",
      render: (text, record, index) => (
        <Form.Item name={[index, "vacation_leave_pay"]} initialValue={0}>
          <Input type="number" disabled />
        </Form.Item>
      ),
    },
    {
      title: "ECOLA Allowance",
      dataIndex: "ecola_allowance",
      key: "ecola_allowance",
      render: (text, record, index) => (
        <Form.Item name={[index, "ecola_allowance"]} initialValue={text}>
          <Input type="number" disabled />
        </Form.Item>
      ),
    },
    {
      title: "Meal Allowance",
      dataIndex: "project_allowance",
      key: "project_allowance",
      render: (text, record, index) => (
        <Form.Item name={[index, "project_allowance"]} initialValue={text}>
          <Input type="number" disabled />
        </Form.Item>
      ),
    },
    {
      title: "Salary Adjustment",
      dataIndex: "salary_adj",
      key: "salary_adj",
      render: (text, record, index) => (
        <Form.Item name={[index, "salary_adj"]} initialValue={0} rules={[{required: true, message: ""}]}>
          <Input type="number" onWheel={(e) => e.target.blur()}/>
        </Form.Item>
      ),
    },
    {
      title: "Incentives",
      dataIndex: "incentives",
      key: "incentives",
      render: (text, record, index) => (
        <Form.Item
          name={[index, "incentives"]}
          initialValue={0}
          rules={[{required: true, message: ""}]}
        >
          <Input
            type="number"
            onWheel={(e) => e.target.blur()}
            onKeyDown={(e) => {
              if (e.key === "-" || e.key === "e") {
                e.preventDefault()
              }
            }}
            onChange={(e) => {
              if (e.target.value < 0) {
                e.target.value = 0
              }
            }}
          />
        </Form.Item>
      ),
    },
    {
      title: "Gross Pay",
      dataIndex: "gross_pay",
      key: "gross_pay",
      render: (text, record, index) => (
        <Input value={tableData[index].gross_pay} type="number" disabled />
      ),
    },

    {
      title: "Late",
      dataIndex: "late",
      key: "late",
      render: (text, record, index) => (
        <Form.Item name={[index, "late"]} initialValue={text}>
          <Input type="number" disabled />
        </Form.Item>
      ),
    },
    {
      title: "Late (hrs)",
      dataIndex: "late_hr",
      key: "late_hr",
      render: (text, record, index) => (
        <Form.Item name={[index, "late_hr"]} initialValue={text}>
          <Input type="number" disabled />
        </Form.Item>
      ),
    },
    {
      title: "Undertime",
      dataIndex: "undertime",
      key: "undertime",
      render: (text, record, index) => (
        <Form.Item name={[index, "undertime"]} initialValue={text}>
          <Input disabled />
        </Form.Item>
      ),
    },
    {
      title: "Undertime (hrs)",
      dataIndex: "undertime_hr",
      key: "undertime_hr",
      render: (text, record, index) => (
        <Form.Item name={[index, "undertime_hr"]} initialValue={text}>
          <Input disabled />
        </Form.Item>
      ),
    },
    // {
    //   title: "Leave Days",
    //   dataIndex: "leave_days",
    //   key: "leave_days",
    //   render: (text, record, index) => (
    //     <Form.Item name={[index, "leave_days"]} initialValue={text}>
    //       <Input disabled/>
    //     </Form.Item>
    //   ),
    // },
    // {
    //   title: "Paid Leave",
    //   dataIndex: "paid_leave",
    //   key: "paid_leave",
    //   render: (text, record, index) => (
    //     <Form.Item name={[index, "paid_leave"]} initialValue={text}>
    //       <Input disabled/>
    //     </Form.Item>
    //   ),
    // },
    {
      title: "SSS",
      dataIndex: "sss",
      key: "sss",
      render: (text, record, index) => (
        <Form.Item name={[index, "sss"]} initialValue={text}>
          <Input type="number" disabled />
        </Form.Item>
      ),
    },
    {
      title: "PhilHealth",
      dataIndex: "philhealth",
      key: "philhealth",
      render: (text, record, index) => (
        <Form.Item name={[index, "philhealth"]} initialValue={text}>
          <Input type="number" disabled />
        </Form.Item>
      ),
    },
    {
      title: "HDMF",
      dataIndex: "hdmf",
      key: "hdmf",
      render: (text, record, index) => (
        <Form.Item name={[index, "hdmf"]} initialValue={text}>
          <Input type="number" disabled />
        </Form.Item>
      ),
    },
    {
      title: "SSS Loan",
      dataIndex: "sss_loan",
      key: "sss_loan",
      render: (text, record, index) => (
        <Form.Item name={[index, "sss_loan"]} initialValue={text}>
          <Input type="number" disabled />
        </Form.Item>
      ),
    },
    {
      title: "Pag-IBIG Loan",
      dataIndex: "pagibig_loan",
      key: "pagibig_loan",
      render: (text, record, index) => (
        <Form.Item name={[index, "pagibig_loan"]} initialValue={text}>
          <Input type="number" disabled />
        </Form.Item>
      ),
    },
    {
      title: "PPEs Loan",
      dataIndex: "ppes_loan",
      key: "ppes_loan",
      render: (text, record, index) => (
        <Form.Item name={[index, "ppes_loan"]} initialValue={text}>
          <Input type="number" disabled />
        </Form.Item>
      ),
    },
    {
      title: "Cash Advance",
      dataIndex: "cash_advance",
      key: "cash_advance",
      render: (text, record, index) => (
        <Form.Item name={[index, "cash_advance"]} initialValue={text}>
          <Input type="number" disabled />
        </Form.Item>
      ),
    },
    {
      title: "Cooperative Loan",
      dataIndex: "cooperative_loan",
      key: "cooperative_loan",
      render: (text, record, index) => (
        <Form.Item name={[index, "cooperative_loan"]} initialValue={text}>
          <Input type="number" disabled />
        </Form.Item>
      ),
    },
    {
      title: "Other Loan",
      dataIndex: "other_loan",
      key: "other_loan",
      render: (text, record, index) => (
        <Form.Item name={[index, "other_loan"]} initialValue={0}>
          <Input type="number" disabled />
        </Form.Item>
      ),
    },

    {
      title: "Coop",
      dataIndex: "coop",
      key: "coop",
      render: (text, record, index) => (
        <Form.Item name={[index, "coop"]} initialValue={0} rules={[{required: true, message: ""}]}>
          <Input
            className="w-100"
            type="number"
            onWheel={(e) => e.target.blur()}
            min={0}
          />
        </Form.Item>
      ),
    },
    {
      title: "Total Deductions",
      dataIndex: "total_deductions",
      key: "total_deductions",
      render: (text, record, index) => (
        <Input
          value={tableData[index].total_deductions}
          type="number"
          disabled
        />
      ),
    },
    {
      title: "Total Net Pay",
      dataIndex: "total_net_pay",
      key: "total_net_pay",
      render: (text, record, index) => (
        <Input value={tableData[index].total_net_pay} type="number" disabled />
      ),
    },
    {
      title: (
        <div className="d-flex justify-content-between">
          Thirteenth Month <Checkbox onChange={handleCheckbox}></Checkbox>
        </div>
      ),
      dataIndex: "thirteenth_month",
      key: "thirteenth_month",
      render: (text, record, index) => (
        <Form.Item name={[index, "thirteenth_month"]} initialValue={text}>
          <Input type="number" disabled />
        </Form.Item>
      ),
    },
  ]

  function chunkArray(array, chunkSize) {
    const chunks = []
    for (let i = 0; i < array.length; i += chunkSize) {
      chunks.push(array.slice(i, i + chunkSize))
    }
    return chunks
  }

  function buildFinalValues(data, tableChunk) {
    const result = {
      date_from: moment(dateFrom.$d).format("YYYY-MM-DD"),
      date_to: moment(dateTo.$d).format("YYYY-MM-DD"),
      is_thirteenth_included: isThirteenthIncluded ? 1 : 0,
      salary_type: salaryType,
      employment_status_id: filterConfig.employment_status_id,
      employee_id: [],
      basic_rate: [],
      work_days: [],
      basic_pay: [],
      regular_ot_hr: [],
      regular_ot_pay: [],
      restday_ot_hr: [],
      restday_ot_pay: [],
      regular_holiday_pay: [],
      special_holiday_pay: [],
      sick_leave_days: [],
      sick_leave_pay: [],
      vacation_leave_days: [],
      vacation_leave_pay: [],
      ecola_allowance: [],
      project_allowance: [],
      gross_pay: [],
      salary_adj: [],
      incentives: [],
      late: [],
      late_hr: [],
      undertime: [],
      undertime_hr: [],
      sss: [],
      philhealth: [],
      hdmf: [],
      sss_loan: [],
      pagibig_loan: [],
      ppes_loan: [],
      cash_advance: [],
      cooperative_loan: [],
      other_loan: [],
      coop: [],
      total_deductions: [],
      thirteenth_month: [],
      total_net_pay: [],
    }

    data.forEach((item, index) => {
      const tableItem = tableChunk[index]
      result.employee_id.push(tableItem.employee_id)
      result.basic_rate.push(item.basic_rate)
      result.work_days.push(item.work_days)
      result.basic_pay.push(item.basic_pay)
      result.regular_ot_hr.push(item.regular_ot_hr)
      result.regular_ot_pay.push(item.regular_ot_pay)
      result.restday_ot_hr.push(item.restday_ot_hr)
      result.restday_ot_pay.push(item.restday_ot_pay)
      result.regular_holiday_pay.push(item.regular_holiday_pay)
      result.special_holiday_pay.push(item.special_holiday_pay)
      result.sick_leave_days.push(item.sick_leave_days)
      result.sick_leave_pay.push(item.sick_leave_pay)
      result.vacation_leave_days.push(item.vacation_leave_days)
      result.vacation_leave_pay.push(item.vacation_leave_pay)
      result.ecola_allowance.push(item.ecola_allowance)
      result.project_allowance.push(item.project_allowance)
      result.gross_pay.push(tableItem.gross_pay)
      result.salary_adj.push(item.salary_adj ?? 0)
      result.incentives.push(item.incentives ?? 0)
      result.late.push(item.late)
      result.late_hr.push(item.late_hr)
      result.undertime.push(item.undertime)
      result.undertime_hr.push(item.undertime_hr)
      result.sss.push(item.sss)
      result.philhealth.push(item.philhealth)
      result.hdmf.push(item.hdmf)
      result.sss_loan.push(item.sss_loan)
      result.pagibig_loan.push(item.pagibig_loan)
      result.ppes_loan.push(item.ppes_loan)
      result.cash_advance.push(item.cash_advance)
      result.cooperative_loan.push(item.cooperative_loan)
      result.other_loan.push(item.other_loan)
      result.coop.push(item.coop ?? 0.0)
      result.total_deductions.push(tableItem.total_deductions)
      result.thirteenth_month.push(tableItem.thirteenth_month)
      result.total_net_pay.push(
        isThirteenthIncluded
          ? getSum([tableItem.total_net_pay, tableItem.thirteenth_month])
          : tableItem.total_net_pay
      )
    })

    return result
  }

  async function uploadByChunk(arrayOfObj) {
    const chunkedArray = chunkArray(arrayOfObj, 15)
    const chunkedTable = chunkArray(tableData, 15)

    // the data is essentially the index of the chunked array
    const promises = []
    chunkedArray.forEach((data, chunkIndex) => {
      const tableChunk = chunkedTable[chunkIndex]
      const finalValues = buildFinalValues(chunkedArray[chunkIndex], tableChunk)
      promises.push(callPost("payrolls/add", finalValues, false, false))
    })

    try {
      await Promise.all(promises)
      toast.success("Successfully generated payroll")
      setSaving(false)
      setTimeout(() => {
        navigate("/payrolls")
      }, 500)
    } catch (error) {
      toast.error("Error generating payroll")
      setSaving(false)
    }
  }

  const onFinish = (formInputs) => {
    setSaving(true)
    const arrayOfValues = Object.values(formInputs)
    uploadByChunk(arrayOfValues)
  }

  // Function to update the totals 1,2,3, and netPay on each value update
  const handleValueChange = (changedValues, allValues) => {
    const changedIndex = parseInt(Object.keys(changedValues)[0])
    const info = allValues[changedIndex]
    const tempTableData = tableData[changedIndex]

    // here we only add the coop and salary adj since they are the only changeable params, the rest are fixed and disabled
    const tempTotalDeduction = getSum([
      tempTableData.original_total_deductions,
      info.coop,
    ])

    const tempGrossPay = getSum([
      tempTableData.original_gross_pay,
      info.salary_adj,
      info.incentives,
    ])
    const totalNetPay = parseFloat(tempGrossPay - tempTotalDeduction).toFixed(2)

    setTableData((prevTableData) => {
      const updatedTableData = [...prevTableData]
      updatedTableData[changedIndex] = {
        ...updatedTableData[changedIndex],
        gross_pay: tempGrossPay,
        total_deductions: tempTotalDeduction,
        total_net_pay: totalNetPay,
      }
      return updatedTableData
    })
  }

  React.useEffect(() => {
    async function fetchAutoFields() {
      setIsDataLoading(true)
      setTableData([])
      const response = await UsePostRequest(
        "payrolls/get_auto_fields",
        filterConfig
      )
      if (response.data) {
        const res = response.data.map((row) => {
          let info = {}

          Object.keys(row).forEach((key) => {
            if (
              // IF THE NUMBER IS PRESENTED AS A STRING, EXTRACT ITS AMOUNT
              row[key] &&
              isValidNumber(row[key]) &&
              !key.includes("date") &&
              !key.includes("id")
            ) {
              info[key] = extractAmount(row[key])
            } else if (row[key] && typeof row[key] === "number") {
              // ELES IF THE NUMBER IS A NUMBER, REDUCE TO 2 DECIMAL PLACES
              info[key] = parseFloat(row[key]).toFixed(2)
            } else {
              info[key] = row[key]
            }
          })

          //explicitly include default values
          info.salary_adj = info.salary_adj ?? 0;
          info.incentives = info.incentives ?? 0;
          info.coop = info.coop ?? 0;

          const tempGrossPay = getSum([
            info.basic_pay,
            info.regular_ot_pay,
            info.restday_ot_pay,
            info.regular_holiday_pay,
            info.special_holiday_pay,
            info.sick_leave_pay,
            info.vacation_leave_pay,
            info.ecola_allowance,
            info.project_allowance,
            info.salary_adj,
            info.incentives,
          ])

          const tempTotalDeduction = getSum([
            info.late,
            info.undertime,
            info.sss,
            info.philhealth,
            info.hdmf,
            info.sss_loan,
            info.pagibig_loan,
            info.ppes_loan,
            info.cash_advance,
            info.cooperative_loan,
            info.other_loan,
            info.coop,
          ])

          const totalNetPay = parseFloat(
            tempGrossPay - tempTotalDeduction
          ).toFixed(2)
          info.gross_pay = tempGrossPay
          info.total_deductions = tempTotalDeduction
          info.original_total_deductions = tempTotalDeduction
          info.original_gross_pay = tempGrossPay
          info.total_net_pay = totalNetPay

          return info
        })

        form.setFieldsValue(res)
        setTableData(res)
      }
      setIsDataLoading(false)
    }

    fetchAutoFields()
  }, [filterConfig])

  return (
    <Navbar activeNav="payroll" formTitle="Generate Payroll" isForm>
      <Card>
        <Form
          form={form}
          name="validateOnly"
          layout="vertical"
          onFinish={onFinish}
          onValuesChange={handleValueChange}
        >
          <div className="payroll-table-wrapper">
            <Table
              dataSource={tableData}
              columns={tableColumns}
              rowKey="key"
              bordered
              pagination={false}
              loading={isDataLoading}
              className="payroll-table-fields"
            />
          </div>
          <Form.Item>
            <Row className="d-flex justify-content-end mt-2">
              <Row>
                <Button
                  className="me-2"
                  danger
                  onClick={() => {
                    navigate("/payrolls")
                  }}
                  disabled={isLoading}
                >
                  Cancel
                </Button>
                <AddSubmitButton form={form} isLoading={isLoading} />
              </Row>
            </Row>
          </Form.Item>
        </Form>
      </Card>

      <Modal open={saving} footer={null} closeIcon={false} centered>
        <Row className="d-flex justify-content-center">
          <Title level={5}>Generating Payroll</Title>
        </Row>
        <Row className="d-flex justify-content-center mt-3">
          <Spin size="large" />
        </Row>
        <Row className="d-flex justify-content-center mt-3">
          Please do not close this window.
        </Row>
      </Modal>
    </Navbar>
  )
}
